import PageImage1 from '../newimages/about/C1.jpg'
import PageImage2 from '../newimages/about/C2.jpg'
import PageImage3 from '../newimages/about/C3.jpg'
import PageImage4 from '../newimages/about/C4.jpg'
import PageImage5 from '../Images/About/5.jpg'
import PageImage6 from '../Images/About/5.jpeg'
import PageImage9 from '../Images/About/9.jpg'
import PageImage10 from '../Images/About/10.jpg'
import PageImage12 from '../Images/About/12.jpg'
import PageImage13 from '../Images/About/Volunteer_03.jpeg'

import PageImageM1 from '../Images/About/3.jpeg'
import PageImageM2 from '../Images/About/1.jpeg'
import PageImageM3 from '../Images/About/2.jpeg'
import PageImageM4 from '../Images/About/1.png'
import PageImageM5 from '../Images/About/2.png'
import PageImageM6 from '../Images/About/3.png'

import Header from '../components/header'
import Footer from '../components/footer'
import Newsletter from '../components/newsletter'

import { HelmetProvider } from 'react-helmet-async';

export default function About() {  
    return (
      <div style={{backgroundColor: '#FFFDF4'}}>
        <HelmetProvider>
            <title>about Us</title>
            <meta name="description" content="About the founders and childen of Sur Saathi a Mumbai-based music initiative offering free choir, rhythm, and performance opportunities for children to build confidence and joy." />
            <link rel="canonical" href="https://sursaathi.in/about" />
        </HelmetProvider>
        <Header />
        <div className='graphicelements'>
        <div className="About-Top-Wave">
        <img src="/bg_images/Top-Con.svg" alt="" />
        </div>
        <div className="green-note" id="green5">
            <img src="/bg_images/Artboard-4.svg" alt="" />
        </div>
        <div className="About-Wave-Left-Page">
        <img src="/bg_images/WaveLine.svg" alt="" />
        </div>
        <div className="About-Wave-Right-Page">
            <img src="/bg_images/wave-left.svg" alt="" />
        </div>
        <div className="About-Line-Left">
            <img src="/bg_images/Line.svg" alt="" />
        </div>
        <div className="green-note" id="green6">
            <img src="/bg_images/Artboard-4.svg" alt="" />
        </div>
        {/*
        <div className="green-note" id="green7">
            <img src="/bg_images/Artboard-4.svg" alt="" />
        </div>
        */}
        <div className="red-note" id="red4">
            <img src="/bg_images/Artboard-2.svg" alt="" />
        </div>
        {/*
        <div className="red-note" id="red5">
            <img src="/bg_images/wave-right.svg" alt="" />
        </div>
        */}
        <div className="yellow-note" id="yellow2">
            <img src="/bg_images/Artboard-3.svg" alt="" />
        </div>
        </div>
        <div className="About-Hero">
            <div className="About-Hero-div">
                <div className="About-Hero-div-info">
                    <h1>
                        Sound. Soul. Saathi.
                    </h1>
                    <p>
                        Our goal is to create a safe, inclusive space where every child feels heard, seen, and celebrated through the universal language of music — with free music education at our core.
                    </p>
                    <a href="/services">Our Education</a>
                </div>

                <div className="About-Hero-Image" > 
                    <div className="About-Hero-Image-Card">
                        <img src={PageImage1} alt="Sur Saathi volunteers perfoming"/>
                    </div>
                    <div className="About-Hero-Image-Card">
                        <img src={PageImage2} alt="Navya Mundhra handing down lyrics sheet"/>
                    </div>
                    <div className="About-Hero-Image-Card">
                        <img src={PageImage3} alt="Keyboard player during music session"/>
                    </div>
                    <div className="About-Hero-Image-Card">
                        <img src={PageImage4} alt="Navya Mundhra during Sur Saathi Session"/>
                    </div>
                </div>
            </div>
        </div>
        <div className="Commnity">
            <div className='graphicelements'>
            <div className="About-Wave-Left">
                <img src="/bg_images/Vector-3.svg" alt="" />
            </div>
            <div className="About-Wave-Right">
                <img src="/bg_images/Vector-2.svg" alt="" />
            </div>
            <div className="green-note" id="green13">
                <img src="/bg_images/Artboard-4.svg" alt="" />
            </div>
            <div className="red-note" id="red9">
                <img src="/bg_images/Artboard-2.svg" alt="" />
            </div>
            </div>
            <div className="Commnity-div">
                <h2>
                    Music That Builds Community
                </h2>
                <p>
                    At Sur Saathi, we believe music is more than melodies and rhythms—it's a bridge that connects hearts, cultures, and communities. Through our music school programs, we create spaces where children discover their voices, build confidence, and form lasting friendships with support and joy.
                </p>
            </div>
        </div>
        <div className='About-Info-Flex'>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImage6} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Navya Mundhra</h2>
                            <h3>Founder</h3>
                            <p>
                                I believe music can inspire change, yet access to it is limited. Trained in violin, piano, and composition, I’m committed to sharing this passion with those who lack the opportunity.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                        <img src={PageImage5} alt="Kanika Jain Founder of Sur Saathi a Music Initiative in Mumbai"/>  
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Kanika Jain</h2>
                            <h3>Co-Founder</h3>
                            <p>
                                Music has given me identity, belonging, and a way to connect with others. Trained in Western and Hindustani Classical singing, I see it as a tool for expression, healing, and unity—and I hope to share these experiences where they’re most needed.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImage9} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Sarthak Kukreja</h2>
                            <h3>Music Lead</h3>
                            <p>
                                I’ve loved music since starting piano at five, and now I’m inspired to share that joy and passion by helping young aspirants pursue their musical dreams.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImage12} alt="Kanika Jain Founder of Sur Saathi a Music Initiative in Mumbai"/>  
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Aarav Bhargava</h2>
                            <h3>Lead Percussionist</h3>
                            <p>
                                I am a musician. From banging away on boxes and pots as a baby, to learning bongos and congas since the age of six to drums, guitar, bass, and music production today, my music journey has gone from strength to strength.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        
    <div className='Volunteers-Section-Main'>
        <h2>Our Team</h2>
        <div className='Volunteers-Section-Flex'>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImage10} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Parnikha Mishra</h2>
                            <h3>Lead Vocalist</h3>
                            <p>
                                I grew from a shy student to a confident performer, exploring music as my true form of expression. Now, at Sur Saathi, my mission is to help new singers find their voice, confidence, and the feeling behind every note.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImageM1} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Kiaan Sharma Sheikh</h2>
                            <h3>Vocalist</h3>
                            <p>
                                I've loved singing since age six and began with Hindustani classical training, inspired by Bollywood music. Singing brings me peace and self-expression. At Sur Saathi, I aim to help others find their voice, express themselves confidently, and experience the joy of music.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImage13} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Elyssa Dsouza</h2>
                            <h3>Vocalist</h3>
                            <p>
                                I've loved singing since I was 7 years old. For me, singing isn't just a hobby, it's a way to express my feelings. And here at Sur Saathi, my aim is to help everyone find their voice and experience the joy of singing.
                            </p>
                        </div>
                    </div>
                </div>
            </div>       
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                        <img src={PageImageM2} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Ahana Banka</h2>
                            <h3>Vocalist & Guitarist</h3>
                            <p>
                                I've loved music for as long as I can remember. From learning guitar at eight to discovering my passion for singing, music has always been central to my life. Through Sur Saathi, I hope to share that passion and inspire others.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImageM3} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Ira Ghosh Nayak</h2>
                            <h3>Vocalist & Violinist</h3>
                            <p>
                                I've been playing the violin since 2021 and have performed at various events. Music helps me express myself and connect with others. At Sur Saathi, I aim to help students build confidence, develop their skills, and enjoy playing the violin.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImageM4} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Aayaan Nandi</h2>
                            <h3>Pianist</h3>
                            <p>
                                I've been playing the violin since 2021 and have performed at various events. Music helps me express myself and connect with others. At Sur Saathi, I aim to help students build confidence, develop their skills, and enjoy playing the violin.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImageM5} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Sriana Kumar Velamakanni</h2>
                            <h3>Vocalist, Guitarist & Music Theory Facilitator</h3>
                            <p>
                                Music has shaped my life from the very beginning. Through guitar, singing, and music theory, I've discovered its power as a form of expression. At Sur Saathi, I hope to help others explore music, grow creatively, and share that same passion
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="About-Info-Section">
                <div className="About-Info-Section-div-2">
                    <div className="About-Info-Section-Images">
                            <img src={PageImageM6} alt="Navya Mundhra Founder of Sur Saathi a Music Initiative in Mumbai"/>
                    </div>
                    <div className="About-Info-Section-Info">
                        <div className="About-Info-Section-Info-div">
                            <h2>Umana Chaudhuri</h2>
                            <h3>Pianist & Guitarist</h3>
                            <p>
                                Music has been a significant part of my life from a young age. As a trained pianist and self-taught guitarist, I enjoy exploring different styles and melodies. Music continues to inspire me, and I’m passionate about sharing that enthusiasm with others.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
         </div>
    </div>
    {/*
    <div className="About-Info-Section">
        <div className="About-Info-Section-div-2-r">
            <div className="About-Info-Section-Info-r">
                <div className="About-Info-Section-Info-r-div">
                    <h2>
                        Creativity Meets Compassion
                    </h2>
                    <p>
                        At Sur Saathi, sessions are more than just singing. They're about expression, listening, and playing together. Our method blends musical learning with emotional growth — where mistakes are welcome, and every voice matters.
                    </p>
                </div>
                <div className="About-Info-Section-Info-r-internal">
                    <img src="/bg_images/Frame 52.png" alt="" />
                </div>
            </div>
            <div className="About-Info-Section-Images">
                <div>
                    <img src={PageImage7}/>
                </div>
                <div>
                    <img src={PageImage8} alt="Children practicing"/>
                </div>
            </div>
        </div>
    </div>
    */}
    {/*
    <div className="Founders-Section">
        <div className="Founders-Section-div">
            <div className="Founders-Section-Info">
                <h2>
                    Meet the Sur Saathi Team
                </h2>
            </div>
            <div className="Founders-Section-Images">
                <div>
                    <img src={PageImage11} alt="Team member" />
                </div>
                <div>
                    <img src={PageImage12} alt="Team member" />
                </div>
            </div>
        </div>
    </div>
    */}
        <div>
            <div className="Newsletter-Section">
                <h2>
                    Stay in Tune with Free Music Education
                </h2>
                <p>
                    Get updates on upcoming events, workshops, and ways you can support music education for children across Mumbai — from free music education sessions to chances to donate instruments in Mumbai.
                </p>
            </div>
        </div>
        <Newsletter />
        <Footer />
    </div>
  );
}
  